export default __webpack_public_path__ + "static/media/gl-15.0db18b9e.png";